import * as React from 'react';
import { useAuth, useTranslation } from '../../../providers';
import { getFinalData } from '../../../services/results';
import {
  AnalysisResults,
  DataAnalyzed,
  DuplicatePaymentsKpiData,
  KPIData,
} from '../../../services/types/results';
import { Translation } from '../../../static';
import { RangeField } from '../../common/RangeField';
import { KPIContainer } from '../styled';
import { BarChart } from './BarChart';
import { DonutChart } from './DonutChart';
import { TileKPI } from './TileKPI';

type Props = KPIData & { data: DuplicatePaymentsKpiData[] };
type KPIType = { kpiData: Props };
const { results } = Translation;

export const AnalysisResultsComponent = ({ kpiData }: KPIType) => {
  const { currency } = useAuth().userInfo.user.client;
  const { translate } = useTranslation();
  const [innerState, setInnerState] = React.useState(kpiData);

  React.useEffect(() => {
    setInnerState(kpiData);
  }, [kpiData]);

  return (
    <KPIContainer>
      <section className='sectionHeader'>{translate(Translation.results.analysisResults)}</section>
      <section style={{ padding: '0 0 10px 0' }}>
        <RangeField
          data={innerState.rawData.map(({ year }) => year)}
          label={translate(Translation.results.rangeOfYears)}
          min={0}
          max={innerState.rawData.length}
          callback={(min, max) => {
            const { rawData } = innerState;
            const {
              rawData: data = [],
              analysisResults = {} as AnalysisResults,
              dataAnalyzed = {} as DataAnalyzed,
            } = getFinalData(rawData.slice(min, max)) ?? {};

            setInnerState({ rawData, data, analysisResults, dataAnalyzed });
          }}
          style={{ width: 300 }}
        />
      </section>
      <section className='container'>
        <TileKPI
          value={innerState.analysisResults.issues}
          title={translate(results.issues)}
          percentage={innerState.analysisResults.percentageIssues}
        />

        <TileKPI
          value={innerState.analysisResults.totalAmmountOfIssues}
          title={translate(results.totalAmountOfIssues)}
          percentage={innerState.analysisResults.totalPercentageIssues}
          currency={currency}
        />

        <TileKPI
          value={innerState.analysisResults.vendors}
          title={translate(results.relatedVendors)}
        />
      </section>

      <section className='analysisResults'>
        <BarChart
          data={innerState.data}
          input='outputAmounts'
          output='issues'
          inputMessage={translate(results.outputAmount)}
          outputMessage={translate(results.issues)}
        />

        <DonutChart data={innerState.data} />
      </section>
    </KPIContainer>
  );
};
